import React, { useEffect, useState } from 'react';
import Header from '../Presale/Header';
import Footer from '../Footer';
import '../css/presale.css'
import Banner from '../Presale/Banner'




import { Container, Row, Col, Card, Button } from 'react-bootstrap';





const Aboutus = () => {



    return (
        <>
            <Header />
            <section className='bg-dark py-5'>
                <Container>
                    <Row>
                        <Col lg={12} className='text-center'>
                            <div className='heading'>
                               <h1 class="text-primary"><b>About Us</b></h1>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className='py-5'>
                <Container>
                    <Row>
                        <Col lg={12}>
                            
                            <p>Inverted Investment is a prestigious organization founded on the backbone of INFI holders. Our organization is driving forward 13 innovative projects, with the first being INFI CDEX - a cutting-edge digital trading platform that encompasses all.</p>

                            <p>Inverted Investment is transforming the financial industry with INFI CDEX, a state-of-the-art digital trading platform. Our platform is distinguished by its unparalleled stability, transparency, decentralization, and top-notch security. It is powered by our self-developed protocol, SbSe (Self-builder Smart ecosystem), which seamlessly integrates the digital world with various sectors like food and beverage, business, real estate, trade, and pharmaceuticals.</p>

                            <p>Our ultimate goal is to implement the SbSe Protocol within an energy-efficient and cost-effective digital WEB4.0-based payment infrastructure. This innovative framework aims to minimize waste and ensure financial benefits for both consumers and businesses. All of this will occur within our exclusive INFI network, a secure and independent ecosystem.</p>

                            <p>At Inverted Investment, we are led by a team of dynamic and highly qualified professionals with extensive experience. Along with INFI CDEX, we will be introducing a series of 13 exceptional projects, revolutionizing the industry one step at a time!</p>
                        </Col>
                    </Row>
                </Container>
            </section>




            {/* <Container>
                <hr className='mt-0 mb-0' />
            </Container> */}
            <Footer className="pt-0" />
        </>
    )
}

export default Aboutus
